/**
 * Coss PDP interactions
 * - Wishlist: custom heart (inside xo-products-fetcher-add so XO saves it)
 * - Custom lightbox: overlay-div approach, bypasses XO gallery shadow DOM
 */
(function () {
  'use strict';

  var STORE_KEY = 'cs_wishlist';

  function getWishlisted() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || '[]'); } catch (e) { return []; }
  }
  function saveWishlisted(ids) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(ids)); } catch (e) {}
  }

  /* ─── Toast ── */
  function showToast(msg, type) {
    var prev = document.querySelector('.cs-toast');
    if (prev) prev.remove();
    var el = document.createElement('div');
    el.className = 'cs-toast' + (type === 'wishlist' ? ' cs-toast--wishlist' : '');
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.textContent = msg;
    document.body.appendChild(el);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.add('cs-toast--visible'); });
    });
    setTimeout(function () {
      el.classList.remove('cs-toast--visible');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 400);
    }, 3000);
  }

  /* ─── Lightbox ── */
  function getLargerSrc(src) {
    if (!src) return src;
    return src.replace(/(_\d+x\d*)(\.(jpg|jpeg|png|webp|gif))(\?.*)?$/i, '_2048x$2');
  }

  function openLightbox(src) {
    var existing = document.getElementById('cs-lb');
    if (existing) existing.remove();

    var overlay = document.createElement('div');
    overlay.id = 'cs-lb';

    var closeBtn = document.createElement('button');
    closeBtn.id = 'cs-lb-close';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '&times;';

    var img = new Image();
    img.alt = '';
    img.src = getLargerSrc(src);

    overlay.appendChild(closeBtn);
    overlay.appendChild(img);
    document.body.appendChild(overlay);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () { overlay.classList.add('cs-lb--open'); });
    });

    function close() {
      overlay.classList.remove('cs-lb--open');
      document.removeEventListener('keydown', keyHandler);
      setTimeout(function () { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }, 300);
    }
    function keyHandler(e) { if (e.key === 'Escape') close(); }

    overlay.addEventListener('click', function (e) {
      if (e.target !== img) close();
    });
    closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', keyHandler);
  }

  /* ─── Overlay-based lightbox triggers ──
     Add a transparent div on top of each main slide so clicks
     hit our div first — bypasses XO's shadow DOM gallery handler */
  function attachLightboxOverlays() {
    document.querySelectorAll(
      '.xo-product-info-media-style3__slide:not([data-cs-lb])'
    ).forEach(function (slide) {
      /* Skip thumbnail slides */
      if (slide.closest('xo-carousel-thumbnail, [class*="thumbnail"]')) return;

      slide.setAttribute('data-cs-lb', '1');

      var trigger = document.createElement('div');
      trigger.className = 'cs-lb-trigger';
      trigger.setAttribute('aria-label', 'Zoom image');

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        var img = slide.querySelector('img');
        if (!img) return;
        openLightbox(img.currentSrc || img.src || '');
      });

      slide.appendChild(trigger);
    });
  }

  /* ─── Wishlist ── */
  function initWishlist() {
    var ids = getWishlisted();
    document.querySelectorAll('.cs-pdp-wish-btn[data-product-id]').forEach(function (btn) {
      var pid = String(btn.getAttribute('data-product-id') || '');
      if (ids.indexOf(pid) !== -1) {
        btn.classList.add('cs-pdp-wish-btn--wishlisted');
        btn.setAttribute('aria-label', 'Remove from wishlist');
      }
    });

    /* Capture phase so we update visual before XO's handler fires */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.cs-pdp-wish-btn[data-product-id]');
      if (!btn) return;
      var pid = String(btn.getAttribute('data-product-id') || '');
      var list = getWishlisted();
      var idx = list.indexOf(pid);
      var added = idx === -1;
      if (added) { list.push(pid); } else { list.splice(idx, 1); }
      saveWishlisted(list);
      btn.classList.toggle('cs-pdp-wish-btn--wishlisted', added);
      btn.setAttribute('aria-label', added ? 'Remove from wishlist' : 'Add to wishlist');
      showToast(added ? '❤ Added to Wishlist' : 'Removed from Wishlist', 'wishlist');
      /* Event continues bubbling — xo-products-fetcher-add receives it and saves to XO wishlist */
    }, true);
  }

  /* ─── PDP thumbnail layout — vertical left strip, height = main image ── */
  var THUMB_W = 70;

  function applyThumbStyles() {
    if (window.innerWidth < 990) return;

    var carousel = document.querySelector('xo-carousel[xo-name="product-information-desktop"]');
    var top      = document.querySelector('.xo-product-info-media-style3__top');
    var thumbs   = document.querySelector('.xo-product-info-media-style3__thumbnails');
    if (!carousel || !top || !thumbs) return;

    /* Carousel: flex row */
    var sp = carousel.style;
    sp.setProperty('display',        'flex',    'important');
    sp.setProperty('flex-direction', 'row',     'important');
    sp.setProperty('align-items',    'stretch', 'important');
    sp.setProperty('gap',            '8px',     'important');

    /* Main image: right, flex-grow */
    var tp = top.style;
    tp.setProperty('flex',      '1 1 auto', 'important');
    tp.setProperty('min-width', '0',        'important');
    tp.setProperty('order',     '1',        'important');

    /* Thumbnail strip: left, fixed width, scrollable */
    var thP = thumbs.style;
    thP.setProperty('order',          '0',          'important');
    thP.setProperty('width',          THUMB_W + 'px', 'important');
    thP.setProperty('min-width',      THUMB_W + 'px', 'important');
    thP.setProperty('max-width',      THUMB_W + 'px', 'important');
    thP.setProperty('flex-shrink',    '0',          'important');
    thP.setProperty('margin-top',     '0',          'important');
    thP.setProperty('overflow-x',     'hidden',     'important');
    thP.setProperty('overflow-y',     'auto',       'important');
    thP.setProperty('scrollbar-width','none',       'important');

    /* Inner list: vertical column */
    var thumbInner = thumbs.querySelector('xo-carousel-inner');
    var thumbList  = thumbs.querySelector('xo-carousel-list, [role="list"]');
    if (thumbInner) {
      var ti = thumbInner.style;
      ti.setProperty('display',         'flex',   'important');
      ti.setProperty('flex-direction',  'column', 'important');
      ti.setProperty('padding',         '0',      'important');
      ti.setProperty('margin',          '0',      'important');
    }
    if (thumbList) {
      var tl = thumbList.style;
      tl.setProperty('display',         'flex',    'important');
      tl.setProperty('flex-direction',  'column',  'important');
      tl.setProperty('gap',             '6px',     'important');
      tl.setProperty('padding',         '0',       'important');
      tl.setProperty('height',          'auto',    'important');
      tl.setProperty('overflow',        'visible', 'important');
      tl.setProperty('transform',       'none',    'important');
    }

    /* Each slide: force 70×70 — override web component's inline size calculation */
    thumbs.querySelectorAll('xo-carousel-slide, .xo-product-info-media-style3__thumb-slide').forEach(function (slide) {
      var sl = slide.style;
      sl.setProperty('width',      THUMB_W + 'px', 'important');
      sl.setProperty('height',     THUMB_W + 'px', 'important');
      sl.setProperty('min-width',  THUMB_W + 'px', 'important');
      sl.setProperty('max-width',  THUMB_W + 'px', 'important');
      sl.setProperty('min-height', THUMB_W + 'px', 'important');
      sl.setProperty('max-height', THUMB_W + 'px', 'important');
      sl.setProperty('overflow',   'hidden',        'important');
      sl.setProperty('flex-shrink','0',             'important');

      slide.querySelectorAll('img, .xo-media, xo-media, picture').forEach(function (img) {
        var ig = img.style;
        ig.setProperty('width',       THUMB_W + 'px', 'important');
        ig.setProperty('height',      THUMB_W + 'px', 'important');
        ig.setProperty('object-fit',  'cover',         'important');
        ig.setProperty('display',     'block',         'important');
      });
    });

    /* Height: match main image */
    var h = top.offsetHeight;
    if (h > 0) thP.setProperty('height', h + 'px', 'important');
  }

  function initThumbnailLayout() {
    applyThumbStyles();

    var top    = document.querySelector('.xo-product-info-media-style3__top');
    var thumbs = document.querySelector('.xo-product-info-media-style3__thumbnails');
    if (!top || !thumbs) return;

    /* Keep syncing height as images load / layout shifts */
    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(function () {
        var h = top.offsetHeight;
        if (h > 0) thumbs.style.setProperty('height', h + 'px', 'important');
      }).observe(top);
    }

    /* Re-apply whenever the web component resets slide styles */
    if (typeof MutationObserver !== 'undefined') {
      var busy = false;
      var mo = new MutationObserver(function () {
        if (busy) return;
        busy = true;
        mo.disconnect();
        applyThumbStyles();
        setTimeout(function () {
          busy = false;
          mo.observe(thumbs, { subtree: true, attributes: true, attributeFilter: ['style'] });
        }, 60);
      });
      mo.observe(thumbs, { subtree: true, attributes: true, attributeFilter: ['style'] });
    }
  }

  /* ─── Style4 thumbnail layout — height = main image, 70px wide strip ── */
  var THUMB4_W = 70;

  function applyStyle4ThumbStyles() {
    if (window.innerWidth < 990) return;

    var right  = document.querySelector('.xo-product-info-media-style4__right');
    var left   = document.querySelector('.xo-product-info-media-style4__left');
    var thumbs = document.querySelector('.xo-product-info-media-style4__thumbnails');
    if (!right || !left || !thumbs) return;

    /* Right: shrink to natural image height */
    right.style.setProperty('align-self', 'flex-start', 'important');

    /* Left: fixed 70px width, scroll vertically */
    var lP = left.style;
    lP.setProperty('width',           THUMB4_W + 'px', 'important');
    lP.setProperty('min-width',       THUMB4_W + 'px', 'important');
    lP.setProperty('max-width',       THUMB4_W + 'px', 'important');
    lP.setProperty('flex-shrink',     '0',             'important');
    lP.setProperty('overflow-y',      'auto',          'important');
    lP.setProperty('overflow-x',      'hidden',        'important');
    lP.setProperty('scrollbar-width', 'none',          'important');

    var h = right.offsetHeight;
    if (h > 0) lP.setProperty('height', h + 'px', 'important');

    /* Inner containers: vertical flex */
    var thumbsInner = left.querySelector('.xo-product-info-media-style4__thumbnails-inner');
    var thumbInner  = thumbs.querySelector('xo-carousel-inner');
    var thumbList   = thumbs.querySelector('xo-carousel-list, [role="list"]');

    if (thumbsInner) {
      thumbsInner.style.setProperty('display',        'flex',   'important');
      thumbsInner.style.setProperty('flex-direction', 'column', 'important');
      thumbsInner.style.setProperty('height',         'auto',   'important');
      thumbsInner.style.setProperty('padding',        '0',      'important');
    }
    if (thumbInner) {
      thumbInner.style.setProperty('display',        'flex',   'important');
      thumbInner.style.setProperty('flex-direction', 'column', 'important');
      thumbInner.style.setProperty('padding',        '0',      'important');
      thumbInner.style.setProperty('margin',         '0',      'important');
    }
    if (thumbList) {
      thumbList.style.setProperty('display',        'flex',    'important');
      thumbList.style.setProperty('flex-direction', 'column',  'important');
      thumbList.style.setProperty('gap',            '6px',     'important');
      thumbList.style.setProperty('padding',        '0',       'important');
      thumbList.style.setProperty('height',         'auto',    'important');
      thumbList.style.setProperty('overflow',       'visible', 'important');
      thumbList.style.setProperty('transform',      'none',    'important');
    }

    /* Each slide: force 70×70 */
    left.querySelectorAll('xo-carousel-slide, .xo-product-info-media-style4__thumb-slide').forEach(function (slide) {
      var sl = slide.style;
      sl.setProperty('width',       THUMB4_W + 'px', 'important');
      sl.setProperty('height',      THUMB4_W + 'px', 'important');
      sl.setProperty('min-width',   THUMB4_W + 'px', 'important');
      sl.setProperty('max-width',   THUMB4_W + 'px', 'important');
      sl.setProperty('min-height',  THUMB4_W + 'px', 'important');
      sl.setProperty('max-height',  THUMB4_W + 'px', 'important');
      sl.setProperty('overflow',    'hidden',         'important');
      sl.setProperty('flex-shrink', '0',              'important');

      slide.querySelectorAll('img, .xo-media, xo-media, picture').forEach(function (img) {
        img.style.setProperty('width',      THUMB4_W + 'px', 'important');
        img.style.setProperty('height',     THUMB4_W + 'px', 'important');
        img.style.setProperty('object-fit', 'cover',          'important');
        img.style.setProperty('display',    'block',           'important');
      });
    });

    /* Force lazy-loaded thumbnail images to load — the constrained container
       height can prevent the IntersectionObserver from firing for lower slides */
    left.querySelectorAll('img').forEach(function (img) {
      /* Switch to eager so the browser fetches it regardless of visibility */
      img.setAttribute('loading', 'eager');
      /* XO lazyload stores the real src in data-src before swapping it in */
      var lazySrc = img.getAttribute('data-src') || img.getAttribute('data-lazy-src');
      if (lazySrc && (!img.src || img.src === window.location.href)) {
        img.src = lazySrc;
      }
    });
    /* Nudge IntersectionObserver-based loaders by firing scroll + resize */
    window.dispatchEvent(new Event('scroll'));
    window.dispatchEvent(new Event('resize'));
  }

  function initStyle4ThumbnailLayout() {
    applyStyle4ThumbStyles();

    var right = document.querySelector('.xo-product-info-media-style4__right');
    var left  = document.querySelector('.xo-product-info-media-style4__left');
    if (!right || !left) return;

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(function () {
        var h = right.offsetHeight;
        if (h > 0) left.style.setProperty('height', h + 'px', 'important');
      }).observe(right);
    }

    if (typeof MutationObserver !== 'undefined') {
      var busy4 = false;
      var mo4 = new MutationObserver(function () {
        if (busy4) return;
        busy4 = true;
        mo4.disconnect();
        applyStyle4ThumbStyles();
        setTimeout(function () {
          busy4 = false;
          mo4.observe(left, { subtree: true, attributes: true, attributeFilter: ['style'] });
        }, 60);
      });
      mo4.observe(left, { subtree: true, attributes: true, attributeFilter: ['style'] });
    }
  }

  /* ─── Sticky ATC: hide when footer is near ──
     IntersectionObserver inline styles beat CSS !important, so JS wins
     cleanly — no fight with xo-sticky's own animation.                */
  function initStickyAtcFooter() {
    if (window.innerWidth > 989) return;
    var bar    = document.querySelector('xo-sticky[xo-name="sticky-addcart"]');
    var footer = document.querySelector('footer, .section-cs-footer');
    if (!bar || !footer) return;

    new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          /* Footer coming into view → fade bar out */
          bar.style.setProperty('opacity', '0', 'important');
          bar.style.setProperty('pointer-events', 'none', 'important');
        } else {
          /* Footer out of view → restore bar */
          bar.style.removeProperty('opacity');
          bar.style.removeProperty('pointer-events');
        }
      });
    }, {
      /* Fire 80px before the footer actually reaches the viewport bottom */
      rootMargin: '0px 0px -0px 0px',
      threshold: 0
    }).observe(footer);
  }

  /* ─── Init ── */
  function init() {
    initWishlist();
    attachLightboxOverlays();
    initStickyAtcFooter();
    /* Re-run after XO potentially re-renders the media (variant change etc.) */
    setTimeout(attachLightboxOverlays, 600);
    setTimeout(attachLightboxOverlays, 2000);

    /* Style3 thumbnail layout */
    setTimeout(applyThumbStyles, 300);
    setTimeout(applyThumbStyles, 900);
    setTimeout(function () { initThumbnailLayout(); }, 2000);

    /* Style4 thumbnail layout */
    setTimeout(applyStyle4ThumbStyles, 300);
    setTimeout(applyStyle4ThumbStyles, 900);
    setTimeout(function () { initStyle4ThumbnailLayout(); }, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
